import {h} from "preact";
import Term from "./Term";
import {useAppContext} from "../../../../../contexts";
import s from "./termsList.module.css";

const TermsList = (props) => {
    // Destructured props
    const {
        handleSearchBar,
        data
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents unwanted errors
    if (!data) {
        return null;
    }

    // Stores all the retrieved terms
    const termList =
        data.map(term => {
            return (
                <Term
                    key={term.url}
                    handleSearchBar={handleSearchBar}
                    term={term}
                />
            )
        })

    return (
        <ul className={`font-museo ${s.root} ${highContrast ? "border-b-[#2f2f2f]" : ""}`}>
            {termList}
        </ul>
    )
}

export default TermsList;
